// import { Type } from '../utils/types'
//
// export type ArrayMergeFilterFunction<U> = (value: U) => boolean
// export type MergeFunction<T, U> = (model: T, value: any, attribute: keyof U, form: U) => void
//
export function IdentitySerializer(o, form, value, attribute) {
    o[attribute] = value;
}
export var IgnoreMergeFunction = function () { };
// export function ArrayMergeFunction<T, U>(
//   FormModel: Type<U>,
//   filterFunction: ArrayMergeFilterFunction<U> = () => true
// ): MergeFunction<T, U> {
//   return (obj: any, value: U[], attribute: any) => {
//     obj[attribute] = (value || [])
//       .filter(filterFunction)
//       .map((value: U, index: number) =>
//         FormModel.prototype.merge(obj[attribute][index], value, attribute)
//       )
//   }
// }
//
// export function BooleanMergeFunction<T>(model: T, value: any, attribute: keyof T): void {
//   model[attribute] = !!value as any
// }
//
// export function IntMergeFunction<T>(model: T, value: any, attribute: keyof T) {
//   const parsed = parseInt(value, 10)
//
//   if (Number.isNaN(parsed)) {
//     model[attribute] = undefined as any
//   } else {
//     model[attribute] = parsed as any
//   }
// }
//
//
// export function TimeNormalise(value: string) {
//   if (value && value.length === 4 && value.indexOf(':') === -1) {
//     value = value.substring(0, 2) + ':' + value.substring(2, 4)
//   }
//
//   return value
// }
//# sourceMappingURL=default-merge-functions.js.map